(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  var closeButtons = document.querySelectorAll('[data-announcement-bar-close]');
  if (!closeButtons.length) return;

  closeButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      var section = button.closest('[data-announcement-bar-section]');
      if (!section) return;

      section.classList.add('is-hidden');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-logos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const marquees = document.querySelectorAll('.marquee-logos');

    if (!marquees.length) return;

    marquees.forEach((marquee) => {
      const handlePointerEnter = () => {
        marquee.classList.add('marquee-logos--paused');
      };

      const handlePointerLeave = () => {
        marquee.classList.remove('marquee-logos--paused');
      };

      marquee.addEventListener('pointerenter', handlePointerEnter);
      marquee.addEventListener('pointerleave', handlePointerLeave);
      marquee.addEventListener('focusin', handlePointerEnter);
      marquee.addEventListener('focusout', handlePointerLeave);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    function getVisibleCount() {
      return mobileQuery.matches ? 1 : 3;
    }

    function initRichTextSlider(sectionEl) {
      if (!sectionEl || sectionEl.dataset.richTextSliderInitialized === 'true') return;
      sectionEl.dataset.richTextSliderInitialized = 'true';

      const items = Array.from(sectionEl.querySelectorAll('.rich-text-slider__item'));
      if (!items.length) return;

      const track = sectionEl.querySelector('.rich-text-slider__track');
      if (!track) return;

      let visibleCount = getVisibleCount();
      let startIndex = 0;

      const prevButton = sectionEl.querySelector('.rich-text-slider__control--prev');
      const nextButton = sectionEl.querySelector('.rich-text-slider__control--next');

      function clampStartIndex() {
        if (startIndex < 0) startIndex = 0;
        if (startIndex + visibleCount > items.length) {
          startIndex = Math.max(0, items.length - visibleCount);
        }
      }

      function update() {
        clampStartIndex();

        const offset = items[startIndex].offsetLeft - items[0].offsetLeft;
        track.style.transform = `translateX(${-offset}px)`;

        items.forEach((item, index) => {
          if (index >= startIndex && index < startIndex + visibleCount) {
            item.removeAttribute('aria-hidden');
            item.tabIndex = 0;
          } else {
            item.setAttribute('aria-hidden', 'true');
            item.tabIndex = -1;
          }
        });

        if (prevButton) {
          prevButton.disabled = startIndex === 0;
        }
        if (nextButton) {
          nextButton.disabled = startIndex + visibleCount >= items.length;
        }
      }

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          if (startIndex > 0) {
            startIndex -= 1;
            update();
          }
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          if (startIndex + visibleCount < items.length) {
            startIndex += 1;
            update();
          }
        });
      }

      // Update visibleCount when viewport crosses the mobile breakpoint
      function handleBreakpointChange() {
        visibleCount = getVisibleCount();
        update();
      }

      window.addEventListener('resize', update);

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', handleBreakpointChange);
      } else if (typeof mobileQuery.addListener === 'function') {
        // Older browsers
        mobileQuery.addListener(handleBreakpointChange);
      }

      update();
    }

    function initRichTextSliders(root) {
      const scope = root || document;
      const sections = scope.matches && scope.matches('[data-rich-text-slider]')
        ? [scope]
        : Array.from(scope.querySelectorAll('[data-rich-text-slider]'));

      sections.forEach(initRichTextSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initRichTextSliders(document));
    } else {
      initRichTextSliders(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initRichTextSliders(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
